"use strict";
exports.__esModule = true;
exports.c_table_m_compact_cell_PaddingLeft = {
  "name": "--pf-v5-c-table--m-compact--cell--PaddingLeft",
  "value": "0.5rem",
  "var": "var(--pf-v5-c-table--m-compact--cell--PaddingLeft)"
};
exports["default"] = exports.c_table_m_compact_cell_PaddingLeft;